"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsxs)("svg", {
    id: "uuid-73bea07b-108e-498c-96ac-baed42d448f1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 467.28 350.07",
    width: "100%",
    height: "100%",
    children: [(0, jsx_runtime_1.jsxs)("g", {
      children: [(0, jsx_runtime_1.jsx)("path", {
        d: "M282.04,174.9V107.13h-27.28c-2.34-7.83-5.48-15.41-9.37-22.56l19.31-19.31-47.92-47.92-19.31,19.31c-7.16-3.89-14.73-7.03-22.56-9.37V0H107.13V27.28c-7.82,2.34-15.4,5.48-22.56,9.37l-19.31-19.31L17.34,65.26l19.31,19.31c-3.89,7.16-7.03,14.74-9.37,22.56H0v67.77H27.28c2.34,7.82,5.48,15.4,9.37,22.56l-19.31,19.31,47.92,47.92,19.31-19.31c7.16,3.89,14.74,7.03,22.56,9.37v27.28h67.77v-14.26l-53.57,.06v-24.17l-1.7-.36c-3.3-.69-6.57-1.54-9.72-2.52-5.91-1.84-11.76-4.29-17.41-7.26-2.94-1.55-5.85-3.26-8.65-5.1l-1.46-.96-17.14,17.14-27.83-27.84,17.14-17.14-.96-1.46c-1.83-2.79-3.55-5.7-5.1-8.65-2.97-5.65-5.42-11.5-7.26-17.41-.98-3.14-1.83-6.41-2.52-9.72l-.36-1.7H14.2v-39.36h24.17l.36-1.7c.69-3.31,1.54-6.58,2.52-9.72,1.84-5.91,4.29-11.76,7.26-17.41,1.55-2.95,3.27-5.86,5.1-8.65l.96-1.46-17.14-17.14,27.83-27.83,17.14,17.14,1.46-.96c2.8-1.84,5.71-3.55,8.65-5.1,5.65-2.97,11.5-5.42,17.41-7.26,3.14-.98,6.41-1.83,9.72-2.52l1.7-.36V14.2h39.36v24.17l1.7,.36c3.31,.69,6.58,1.54,9.72,2.52,5.91,1.85,11.77,4.29,17.41,7.26,2.95,1.55,5.85,3.26,8.65,5.1l1.46,.96,17.14-17.14,27.83,27.83-17.14,17.14,.96,1.46c1.83,2.79,3.55,5.7,5.1,8.65,2.98,5.65,5.42,11.51,7.26,17.41,.98,3.14,1.83,6.41,2.52,9.72l.36,1.7h24.17v39.36h-24.17l-.36,1.7c-.69,3.31-1.54,6.58-2.52,9.72-1.84,5.91-4.29,11.76-7.26,17.41-1.55,2.95-3.27,5.86-5.1,8.65l-.96,1.46,17.14,17.14-27.83,27.84-17.14-17.14-1.46,.96c-2.79,1.83-5.7,3.55-8.66,5.1l-2.66,1.33,9.4,9.42,1.19,1.11h0l19.31,19.31,47.92-47.92-19.31-19.31c3.89-7.16,7.03-14.73,9.37-22.56h27.28Z",
        fill: "currentColor"
      }), (0, jsx_runtime_1.jsx)("path", {
        d: "M141.02,77.47c-35.04,0-63.55,28.51-63.55,63.55s28.51,63.55,63.55,63.55,63.55-28.51,63.55-63.55-28.51-63.55-63.55-63.55Zm49.91,63.55c0,27.52-22.39,49.91-49.91,49.91s-49.91-22.39-49.91-49.91,22.39-49.91,49.91-49.91,49.91,22.39,49.91,49.91Z",
        fill: "currentColor"
      })]
    }), (0, jsx_runtime_1.jsx)("circle", {
      cx: "401.95",
      cy: "50",
      r: "31.33",
      fill: "none",
      stroke: "currentColor",
      strokeMiterlimit: "10",
      strokeWidth: "14px"
    }), (0, jsx_runtime_1.jsx)("polyline", {
      points: "236.74 86.82 311.8 86.82 336.21 50 370.62 50",
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeMiterlimit: "10",
      strokeWidth: "10px"
    }), (0, jsx_runtime_1.jsx)("circle", {
      cx: "401.95",
      cy: "230.64",
      r: "31.33",
      fill: "none",
      stroke: "currentColor",
      strokeMiterlimit: "10",
      strokeWidth: "14px"
    }), (0, jsx_runtime_1.jsx)("polyline", {
      points: "236.74 193.83 311.8 193.83 336.21 230.64 365.12 230.64",
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeMiterlimit: "10",
      strokeWidth: "10px"
    }), (0, jsx_runtime_1.jsx)("polyline", {
      points: "241.94 234.27 298.13 234.27 330.1 283.47",
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeMiterlimit: "10",
      strokeWidth: "10px"
    }), (0, jsx_runtime_1.jsx)("circle", {
      cx: "343.73",
      cy: "311.74",
      r: "31.33",
      fill: "none",
      stroke: "currentColor",
      strokeMiterlimit: "10",
      strokeWidth: "14px"
    }), (0, jsx_runtime_1.jsx)("line", {
      x1: "278.93",
      y1: "142.47",
      x2: "398.15",
      y2: "142.47",
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeMiterlimit: "10",
      strokeWidth: "10px"
    }), (0, jsx_runtime_1.jsx)("circle", {
      cx: "428.95",
      cy: "140.32",
      r: "31.33",
      fill: "none",
      stroke: "currentColor",
      strokeMiterlimit: "10",
      strokeWidth: "14px"
    })]
  });
};

exports.default = Icon;